module.exports = __webpack_public_path__ + "static/media/keelings.0b8b5f5d.png";